import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { api } from "@/lib/api";
import { ArrowUpRight } from "lucide-react";

export default function BlogPreview() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data.slice(0, 3))).catch(() => {});
  }, []);

  return (
    <section className="bg-cream py-24 md:py-36 border-t border-black/10" data-testid="blog-preview">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <Reveal className="flex flex-wrap items-end justify-between gap-6 mb-16">
          <div>
            <span className="font-sans uppercase tracking-[0.35em] text-[11px] text-amber-deep">The Journal</span>
            <h2 className="mt-5 font-serif text-4xl md:text-6xl leading-[0.95] text-obsidian">
              Notes on hair<br /><span className="italic">& scalp.</span>
            </h2>
          </div>
          <Link to="/blog" className="group inline-flex items-center gap-2 font-sans uppercase tracking-[0.2em] text-xs text-obsidian hover:text-amber-deep transition-colors">
            Read the journal
            <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </Link>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-x-8 gap-y-12">
          {posts.map((p, i) => (
            <Reveal
              as="article"
              key={p.slug}
              delay={i * 0.08}
              className="group"
              data-testid={`blog-card-${p.slug}`}
            >
              <Link to={`/blog/${p.slug}`}>
                <div className="relative overflow-hidden aspect-[4/3] bg-sand">
                  <img src={p.cover} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="mt-5">
                  <p className="font-sans uppercase tracking-[0.2em] text-[10px] text-amber-deep">{p.category} · {p.read_time}</p>
                  <h3 className="mt-2 font-serif text-2xl leading-tight text-obsidian group-hover:text-amber-deep transition-colors">{p.title}</h3>
                  <p className="mt-2 font-sans font-light text-sm text-obsidian/60 leading-relaxed">{p.excerpt}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
